import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Customer } from '../../models/customer.model';
import { Permission } from '../../models/permission.model';
import { Role } from '../../models/role.model';
import { UserEdit } from '../../models/user-edit.model';
import { User } from '../../models/user.model';
import { AccountService } from '../../services/account.service';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { fadeInOut } from '../../services/animations';
import { AuthService } from '../../services/auth.service';
import { DBkeys } from "../../services/db-Keys";
import { EventService } from '../../services/event.service';
import { RoleServices } from '../../services/roles.service';
import { Utilities } from '../../services/utilities';
import { Subscription } from 'rxjs';

// let _ = require('lodash');

@Component({
    selector: 'users-add-update',
    template: require('./users-add-update.component.html'),
    styles: [require('./users-add-update.component.css')],
    animations: [fadeInOut]
})
export class UsersAddUpdateComponent implements OnInit, OnDestroy {

    private subscribers: Subscription[] = [];

    mode: string = "Toevoegen";
    user: User = new User;
    userEdit: UserEdit = new UserEdit;
    loading: boolean = false;
    isEnableValue: boolean = false;
    allRoles: Role[] = [];
    rrole: Role[] = [];
    selectedData: any;
    isEditablePermission: boolean = false;
    DBkeys = DBkeys;
    mindate: Date;
    maxdate: Date = new Date();
    defaultAppRoleNames: any;
    registerType: string;
    ddRegisterTypes: string[] = [];


    constructor(private userService: AccountService, private router: Router, private activatedRoute: ActivatedRoute,
        private alertService: AlertService, private ngxLogger: NGXLogger, private eventService: EventService,
        private roleService: RoleServices, private authService: AuthService) { }

    ngOnInit() {
        this.ddRegisterTypes.push('Bedrijf');
        this.ddRegisterTypes.push('Particulier');
        this.registerType = 'Bedrijf';

        const paramSubscriber = this.activatedRoute.params.subscribe(params => {
            if (params['id']) {
                this.isEditablePermission = this.caneditUsersPermission;
                this.userEdit.Id = params['id'];
                this.mode = "Bewerk";
                this.getById();
            } else {
                this.isEditablePermission = this.canaddUsersPermission;
                this.mode = "Toevoegen";
                this.userEdit = new UserEdit();
                // this.userEdit.IsTrial = this.userEdit.IsExtented = this.userEdit.IsPermanent = false;
                this.userEdit.IsEnabled = true;
                this.userEdit.Customer = new Customer();
            }
        });

        this.subscribers.push(paramSubscriber);

        this.getRolesAndDefaultApplicationRoleNames();
        this.mindate = new Date(2015, 1, 0);
        this.maxdate.setDate(new Date().getDate() + (365 * 30)); // Add 30 years to Current Date
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    // getRoles() {
    //     this.userService.getRoles().subscribe(response => {
    //         this.allRoles = response;
    //         this.rrole = this.allRoles;
    //         if (this.mode == "Toevoegen") {
    //             this.userEdit.RoleId = this.rrole[0].Name;
    //         }
    //     });
    // }

    getRolesAndDefaultApplicationRoleNames() {
        const roleNamesSubscriber = this.roleService.getRolesAndDefaultApplicationRoleNames().subscribe(data => {
            if (data && data != null) {
                this.allRoles = data[0];
                this.rrole = this.allRoles;
                this.defaultAppRoleNames = data[1];
                if (this.mode == "Toevoegen") {
                    this.userEdit.RoleId = this.rrole[0].Name;
                }
                if (this.authService.currentUser && this.rrole && this.rrole.length > 0 && this.defaultAppRoleNames != null) {
                    const currentUserDefaultRoleName = this.allRoles.find(f => f.Name === this.authService.currentUser.RoleId);
                    switch (currentUserDefaultRoleName.DefaultRoleName) {
                        case this.defaultAppRoleNames['SuperAdmin']:
                            break;

                        case this.defaultAppRoleNames['Admin']:
                            this.rrole = this.rrole.filter(k => k.DefaultRoleName !== this.defaultAppRoleNames['SuperAdmin'] && k.DefaultRoleName !== this.defaultAppRoleNames['ThirdPartyAdmin'])
                            break;
                        case this.defaultAppRoleNames['ThirdPartyAdmin']:
                            this.rrole = this.rrole.filter(k => k.DefaultRoleName !== this.defaultAppRoleNames['SuperAdmin'] && k.DefaultRoleName !== this.defaultAppRoleNames['Admin'] && k.IsVisibleToThirdParty == true)
                            break;

                        default:
                            this.rrole = this.rrole.filter(k => k.DefaultRoleName !== this.defaultAppRoleNames['SuperAdmin'] && k.DefaultRoleName !== this.defaultAppRoleNames['Admin'] && k.DefaultRoleName !== this.defaultAppRoleNames['ThirdPartyAdmin'])
                            break;
                    }
                }
            }
        });
        this.subscribers.push(roleNamesSubscriber);
    }

    changeRole(event: any) {
        const selectedRole = this.allRoles.find(f => f.Name === this.userEdit.RoleId);
        if (selectedRole != null && this.defaultAppRoleNames != null) {
            if (selectedRole.DefaultRoleName === this.defaultAppRoleNames['SuperAdmin'] || selectedRole.DefaultRoleName === this.defaultAppRoleNames['Admin']) {
                this.userEdit.IsPermanent = true;
                this.userEdit.IsTrial = false;
                this.userEdit.IsExtented = false;
            } else {
                this.userEdit.IsPermanent = false;
                this.userEdit.IsTrial = true;
            }
        } else {
            this.userEdit.IsPermanent = false;
            this.userEdit.IsTrial = true;
        }
    }

    extended(userId?: string) {
        if (this.userEdit.ExpireDate == null) {
            this.alertService.showMessage("User", "Expire date must not be empty.", MessageSeverity.error);
        } else {
            if (this.userEdit.IsEnabled) {
                let newExpireDate: Date = new Date();
                if (this.userEdit.ExpireDate && this.userEdit.ExpireDate != undefined) {
                    newExpireDate = new Date(this.userEdit.ExpireDate);
                }
                newExpireDate.setFullYear(newExpireDate.getFullYear() + 1);
                this.userEdit.ExpireDate = new Date(newExpireDate);
                // var dformat
                //     = [this.userEdit.ExpireDate.getDate(),
                //     this.userEdit.ExpireDate.getMonth() + 1,
                //     this.userEdit.ExpireDate.getFullYear()].join('-');

                // this.userService.getUserExpireExtend(userId, dformat.toString()).subscribe(user => {
                //     let tempUser: any = user;
                //     this.alertService.showMessage("User", "Licence has been extented for" + DBkeys.EXTEND_YEARS + " " + "Year" + " " + "Successfully!", MessageSeverity.success);
                //     this.mode = "Bewerk";
                //     this.userEdit.ExpireDate = new Date(tempUser.ExpireDate);
                // },
                //     error => {
                //         const errorMessage = Utilities.findHttpResponseMessage("error_description", error);
                //         if (errorMessage == 'in trial period') {
                //             this.alertService.showStickyMessage(this.userEdit.Email, 'u kunt expiratie niet verlengen omdat deze gebruiker in proefperiode is!', MessageSeverity.warn);
                //         }

                //     });
            } else {
                this.alertService.showMessage('User', 'You can not extend expiry of disable user.', MessageSeverity.error);
            }
        }
    }

    createUpdate(form: NgForm) {
        if (this.isEditablePermission) {

            // To avoid removing the disable HTML attributes and approve User w/o actual permission
            if (!this.canapproveUsersPermission) {
                this.userEdit.IsEnabled = this.isEnableValue;
            }
            this.userEdit.UserName = this.userEdit.Email;
            this.userEdit.Email = this.userEdit.Customer.Email;

            if (form.valid) {
                this.toggleProcessing(true);
                if (this.mode == "Toevoegen") {
                    const newUserSubscriber = this.userService.newUser(this.userEdit).subscribe(user => {
                        this.toggleProcessing(false);
                        this.alertService.showMessage('Gebruiker', 'Gebruiker met succes bewaard!', MessageSeverity.success);
                        this.alertService.showMessage('Gebruiker', 'Gebruiker registratie e-mail verzonden naar de gebruiker!', MessageSeverity.success);
                        this.router.navigate(['users']);
                    }, error => {
                        this.toggleProcessing(false);
                        const errorMessage = Utilities.findHttpResponseMessage("error_description", error);
                        if (errorMessage == 'Email Exists') {
                            this.alertService.showMessage(this.userEdit.Email, 'bestaat al!', MessageSeverity.error);
                        } else if (errorMessage == 'BTW Exists') {
                            this.alertService.showMessage(this.userEdit.Customer.BTW, 'bestaat al!', MessageSeverity.error);
                        } else if (errorMessage == 'Migration Failed') {
                            this.alertService.showMessage('Migratie mislukt', 'Migratie van proefgebruikercontractbestanden mislukt!', MessageSeverity.error);
                        } else if (errorMessage == 'User Exists') {
                            this.alertService.showMessage(this.userEdit.Email, 'je kunt geen gebruiker toevoegen omdat deze al bestaat!', MessageSeverity.error);
                        } else {
                            this.alertService.showStickyMessage('Fout', 'Er is iets fout gegaan', MessageSeverity.error);
                        }
                    });
                    this.subscribers.push(newUserSubscriber);
                } else {
                    const updateUserSubscriber = this.userService.updateUser(this.userEdit).subscribe(user => {
                        this.toggleProcessing(false);
                        this.alertService.showMessage('Gebruiker', 'Gebruiker met succes bewaard!', MessageSeverity.success);
                        this.router.navigate(['users']);
                    }, error => {
                        this.toggleProcessing(false);
                        const errorMessage = Utilities.findHttpResponseMessage("error_description", error);
                        if (errorMessage == 'Email Exists') {
                            this.alertService.showMessage(this.userEdit.Email, 'bestaat al!', MessageSeverity.error);
                        } else if (errorMessage == 'BTW Exists') {
                            this.alertService.showMessage(this.userEdit.Customer.BTW, 'bestaat al!', MessageSeverity.error);
                        } else {
                            this.alertService.showStickyMessage('Fout', 'Er is iets fout gegaan', MessageSeverity.error);
                        }
                    });
                    this.subscribers.push(updateUserSubscriber);
                }
            }

            //    this.userService.newUser(this.userEdit).subscribe((res: UserEdit) => {
            //        if (res) {
            //            this.alertService.showMessage('User', 'Gebruiker met succes bewaard!', MessageSeverity.success);
            //            this.router.navigate(['users']);
            //        }
            //    }, error => {
            //        this.ngxLogger.error(error.message);
            //        throw error;
            //    });
        }
    }

    getById() {
        this.loading = true;
        const getUserSubscriber = this.userService.getUser(this.activatedRoute.snapshot.params["id"]).subscribe((res: UserEdit) => {
            this.userEdit = res;
            this.isEnableValue = this.userEdit.IsEnabled;

            if (this.userEdit.ExpireDate != null) {
                this.userEdit.ExpireDate = new Date(this.userEdit.ExpireDate);
            } else {
                this.userEdit.ExpireDate = null;
            }
            if (this.userEdit && this.userEdit.Customer) {
                this.registerType = this.userEdit.Customer.BTW !== '' && this.userEdit.Customer.BTW !== null ? 'Bedrijf' : 'Particulier';
            }
            this.loading = false;

        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getUserSubscriber);
    }

    toggleRadioGroupClick(elementName: string, value: boolean = true) {
        switch (elementName) {
            case 'IsTrial':
                this.userEdit.IsTrial = true;
                this.userEdit.IsExtented = false;
                this.userEdit.IsPermanent = false;
                break;
            case 'IsExtented':
                this.userEdit.IsExtented = true;
                this.userEdit.IsTrial = false;
                this.userEdit.IsPermanent = false;
                break;
            case 'IsPermanent':
                this.userEdit.IsPermanent = value;
                this.userEdit.IsExtented = false;
                this.userEdit.IsTrial = false;
                break;

            default:
                break;
        }
    }

    toggleProcessing(processState: boolean = false) {
        if (processState) {
            this.eventService.showProcessingSpinner();
        } else {
            this.eventService.hideProcessingSpinner();
        }
    }

    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }

    get canaddUsersPermission() {
        return this.userService.userHasPermission(Permission.addUsersPermission);
    }

    get caneditUsersPermission() {
        return this.userService.userHasPermission(Permission.editUsersPermission);
    }

    get canapproveUsersPermission() {
        return this.userService.userHasPermission(Permission.approveUsersPermission);
    }

    get canmanageUsersUsageSettings() {
        return this.userService.userHasPermission(Permission.manageUsersUsageSettings);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/users/users-add-update.component.ts